import { Injectable, inject } from '@angular/core';
import { DbService } from '../db/db.service';
import { Project } from '../../models/project';
import { User } from '../../models/user';
import { Favorite } from '../../models/favorite';
import { FavoriteTypeEnum } from '../../enums/favoriteType.enum';
import { CourseEnrollment } from '../../models/courseEnrollment';
import { CourseEnrollmentService } from '../course-enrollment/course-enrollment.service';

@Injectable({
	providedIn: 'root'
})
export class FavoriteService {
	private db = inject(DbService);
	private courseEnrollmentService = inject(CourseEnrollmentService);

	constructor(
	) { }

	async markOrUnmark(courseEnrollment: CourseEnrollment, categroyId: string, categoryName: string, user: User, projectId: string, mark: boolean, type: FavoriteTypeEnum, chapterIndex?: number) {
		const favoriteCoursePath = this.db.getProyIdRef(projectId).collection(User.PATH).doc(user.id).collection(Favorite.PATH);
		let favorite:Favorite;
		if (type == FavoriteTypeEnum.COURSE) {
			if (courseEnrollment.isFavorite) {
				await this.delete(courseEnrollment.id,user.id,projectId);
			} else {
				favorite = await this.createFavoriteEntity(courseEnrollment, categroyId, categoryName, type);
				await favoriteCoursePath.doc(courseEnrollment.id).set(favorite.toJson(), { merge: true });
			}
			this.courseEnrollmentService.setAsFavorite(categroyId, courseEnrollment.id, user.id, projectId, mark);
		} else if (type == FavoriteTypeEnum.CHAPTER) {
			const chapterEnrollment = courseEnrollment.chapterEnrollments[chapterIndex];
			if (chapterEnrollment.isFavorite) {
				await this.delete(chapterEnrollment.id,user.id,projectId);
			} else {
				favorite = await this.createFavoriteEntity(courseEnrollment, categroyId, categoryName, type, chapterIndex);
				await favoriteCoursePath.doc(chapterEnrollment.id).set(favorite.toJson(), { merge: true });
			}
			courseEnrollment.chapterEnrollments[chapterIndex].isFavorite = mark;
			this.courseEnrollmentService.save(courseEnrollment, user.id, categroyId, courseEnrollment.id, projectId);
		}
	}

	private async createFavoriteEntity(courseEnrollment: CourseEnrollment, categroyId: string, categoryName: string, type: FavoriteTypeEnum, chapterIndex?: number) {
		let favorite = new Favorite();
		favorite.categoryName = categoryName;
		favorite.courseName = courseEnrollment.name;
		favorite.courseNameLowercase = courseEnrollment.name.toLowerCase();
		favorite.courseImage = courseEnrollment.image;
		favorite.categoryId = categroyId;
		favorite.courseId = courseEnrollment.id;
		favorite.duration = courseEnrollment.duration;
		favorite.type = type;

		if (type == FavoriteTypeEnum.COURSE) {
			favorite.id = courseEnrollment.id;
			favorite.duration = courseEnrollment.duration;
			favorite.totalChapters = courseEnrollment.totalChapters;
		} else if (type == FavoriteTypeEnum.CHAPTER) {
			const chapterEnrollment = courseEnrollment.chapterEnrollments[chapterIndex];
			favorite.id = chapterEnrollment.id;
			favorite.chapterName = chapterEnrollment.name;
			favorite.chapterNameLowercase = chapterEnrollment.name.toLowerCase();
			favorite.quiz = chapterEnrollment.hasQuiz;
			favorite.video = chapterEnrollment.hasVideo;
			favorite.chapterIndex = chapterIndex;
		}
		return favorite;
	}

	async getAll(user: User, projectId: string, type: FavoriteTypeEnum) {
		const favoritePath = this.db.getProyIdRef(projectId).collection(User.PATH).doc(user.id).collection(Favorite.PATH)
		const snapshot = await favoritePath.where('is_deleted', '==', false).where('type', '==', type).get();
		if (snapshot.empty) {
			return null
		}
		const favorites = Promise.all(snapshot.docs.map(async doc => {
			return new Favorite(doc.data())
		}));
		return favorites;
	}

	async unmarkExistent(favorite: Favorite, user: User, projectId: string) {
		let courseEnrollment = await this.courseEnrollmentService.get(user.id, favorite.categoryId,favorite.courseId,projectId);
		if (favorite.type == FavoriteTypeEnum.COURSE) {
			this.courseEnrollmentService.setAsFavorite(favorite.categoryId, courseEnrollment?.id, user.id, projectId, false);
		} else if (favorite.type == FavoriteTypeEnum.CHAPTER) {
			courseEnrollment.chapterEnrollments[favorite.chapterIndex].isFavorite = false;
			this.courseEnrollmentService.save(courseEnrollment, user.id, favorite.categoryId, courseEnrollment.id, projectId);
		}
		await this.delete(favorite.id, user.id, projectId);
	}

	async delete(id: string, userId: string, projectId: string) {
		const favoriteCoursePath = this.db.getProyIdRef(projectId).collection(User.PATH).doc(userId).collection(Favorite.PATH);
		await favoriteCoursePath
			.doc(id)
			.update({ 'is_deleted': true });
	}
}
